import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import{ environment } from "../../environments/environment";
import {HttpClient} from '@angular/common/http';
import {jwtDecode} from 'jwt-decode';
import {LoginResponse} from "../types/login-response.type";
import {tap} from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private router = inject(Router);
  private token: string | null = null;
  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  private isSessionStorageAvailable(): boolean {
    return typeof window !== 'undefined' && typeof sessionStorage !== 'undefined';
  }

  login(username: string, password: string){
    return this.httpClient.post<LoginResponse>(`${this.apiUrl}/auth/login`, {username,password}).pipe(
      tap((value) => {
        sessionStorage.setItem('token', value.token);
        sessionStorage.setItem('loginOrigin', 'local');
      })
    )
  }

  getAuthorizationToken() {
    return sessionStorage.getItem('token');
  }

  getTokenExpirationDate(token: string): Date | null {
    const decoded: { exp?: number } = jwtDecode(token);
    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) {
      return true;
    }
    const date = this.getTokenExpirationDate(token);
    if (!date || date <= new Date()) {
      sessionStorage.removeItem('token');
      this.logout();
      return true;
    }
    return false;
  }

  logout(): void {
    if (this.isSessionStorageAvailable()) {
      const loginOrigin = sessionStorage.getItem('loginOrigin');
  
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('loginOrigin');
      this.token = null;
  
      if (loginOrigin === 'central') {
        // Redireciona para a pÃ¡gina de login da Central
        window.location.href = environment.centralLogoutUrl;
        return;
      }
    }
  
    // Redireciona para tela de login local
    this.router.navigate(['/login']);
  } 

  isAuthenticated(): boolean {
    const token = this.getAuthorizationToken();
    if (!token) {
      return false;
    } else if (this.isTokenExpired(token)) {
      return false;
    }
    return true;
  }

  obterLinkMoodle(): Observable<{ link: string }> {
    return this.httpClient.get<{ link: string }>(`${this.apiUrl}/moodle`);
  }
}